import utils from '@/utils';
import fetch from './fetch';

// 学员相关
const contactQuery = (params) => fetch({ url: '/contact_query', params: { ...params, page_size: 15, page_no: 1 } });
const discountReasonQuery = () => fetch({ url: '/get_discount_reason_list' });
// 报名相关
const eduSignUp = ({ params }) => fetch({ url: '/edu_sign_up', params, methold: 'post' });
const ministerSignUp = ({ params }) => fetch({ url: '/minister_sign_up', params, methold: 'post' });
const getSignUpFee = ({ params }) => fetch({ url: '/get_sign_up_fee', params });
const activateSignUp = ({ params }) => fetch({ url: '/activate_sign_up', params, methold: 'post' });
const revokeSignUp = ({ params }) => fetch({ url: '/revoke_sign_up', params, methold: 'post' });
const signUpDetail = (params) => fetch({ url: '/sign_up_detail', params });

const interviewDetail = (params) => fetch({ url: '/interview_detail', params });
const passInterview = ({ params }) => fetch({ url: '/pass_interview', params, methold: 'post' });
const rejectInterview = ({ params }) => fetch({ url: '/reject_interview', params, methold: 'post' });

const groupSignUp = ({ params }) => fetch({ url: '/group_sign_up', params, methold: 'post' });
const groupSignUpClass = (params) => fetch({ url: '/group_sign_up_class_list', params });
const groupSignUpStudent = ({ params }) => fetch({ url: '/group_sign_up_student_list', params });

const rockingNumber = ({ params }) => fetch({ url: '/rocking_number', params, methold: 'post' });
const getRockingNumber = (params) => fetch({ url: '/get_rocking_number_result', params });

const discountSignUp = ({ params }) => fetch({ url: '/discount_sign_up', params, methold: 'post' });
const getStudentDetail = ({ params }) => fetch({ url: '/get_student_detail', params });
const getStudentSignUpDetail = (params) => fetch({ url: '/get_student_sign_up_detail', params });
const transferClass = ({ params }) => fetch({ url: '/transfer_class', params, methold: 'post' });
const transferClassQuery = ({ params }) => fetch({ url: '/transfer_class_query', params });
const getStudentCheckInfo = (params) => {
  let newParam = { ...params };
  delete newParam.class_id;

  return fetch({ url: `/get_student_check/${params.class_id}`, params: newParam });
};
// 报名学员
const signUp = (params) => fetch({ url: '/sign_up', params });
const getSignUpInfo = ({ params }) => fetch({ url: '/get_sign_up_info', params });
// 学员
const getStudent = (params) => fetch({ url: '/student', params });
const exportStudent = ({ params }) =>
  fetch({
    url: '/export_student_list',
    params,
    isFull: true,
    config: { responseType: 'blob' },
  });

const exportSignUpDetails = ({ params }) =>
  fetch({
    url: '/export_sign_up_details',
    params,
    isFull: true,
    config: { responseType: 'blob' },
  });

const exportSignUp = ({ params }) =>
  fetch({
    url: '/export_sign_up',
    params,
    isFull: true,
    config: { responseType: 'blob' },
  });

// 保险
const getStudentInsurance = (params) => fetch({ url: '/class_student_insurance_query', params });
const checkClassTimeConflict = ({ params }) => fetch({ url: '/check_class_time_conflict', params });
const exportStudentInsurance = ({ params }) =>
  fetch({
    url: '/export_student_insurance',
    params,
    isFull: true,
    config: { responseType: 'blob' },
  });

// 一键激活
const oneKeyActivate = (params) => fetch({ url: `/one_key_activate?${utils.objToUrl(params)}`, methold: 'post' });
const checkActivateStatus = ({ task_id }) => fetch({ url: `/check_activate_status/${task_id}` });

// 集体报名名额单独数字
const getGroupQuota = ({ class_id }) => fetch({ url: `/group_sign_up_real_quota/${class_id}` });

export default {
  checkActivateStatus,
  oneKeyActivate,
  exportStudentInsurance,
  checkClassTimeConflict,
  exportSignUp,
  getStudentInsurance,
  exportSignUpDetails,
  contactQuery,
  discountReasonQuery,
  eduSignUp,
  ministerSignUp,
  getSignUpFee,
  activateSignUp,
  revokeSignUp,
  passInterview,
  rejectInterview,
  groupSignUp,
  signUpDetail,
  rockingNumber,
  getRockingNumber,
  interviewDetail,
  groupSignUpClass,
  groupSignUpStudent,
  signUp,
  discountSignUp,
  getStudentDetail,
  getStudentSignUpDetail,
  transferClass,
  transferClassQuery,
  getSignUpInfo,
  getStudent,
  exportStudent,
  getStudentCheckInfo,
  getGroupQuota,
};
